import { User } from "@/shared";

export function getUserFio(user: User) {
  return `${user?.last_name || ''} ${user?.first_name || ''} ${user?.middle_name || ''}`.trim()
}
